import { render, staticRenderFns } from "./addRetail.vue?vue&type=template&id=7dc92b10&scoped=true&"
import script from "./addRetail.vue?vue&type=script&lang=js&"
export * from "./addRetail.vue?vue&type=script&lang=js&"
import style0 from "./addRetail.vue?vue&type=style&index=0&id=7dc92b10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc92b10",
  null
  
)

export default component.exports